import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { AuditorExportDialog } from '@/components/auditor-export/index';

export function AuditorExportExample() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="space-y-4 p-4 border rounded-lg">
      <h2 className="text-xl font-semibold">Auditor Export Example</h2>
      <p className="text-sm text-muted-foreground">
        This example shows how to use the AuditorExportDialog component to export audit packs.
      </p>
      
      <Button onClick={() => setIsOpen(true)}>
        Open Auditor Export
      </Button>
      
      <AuditorExportDialog 
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onExportComplete={() => {
          console.log('Export completed');
        }}
        onError={(error) => {
          console.error('Export error:', error);
        }}
      />
    </div>
  );
}
